import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MustMatch } from 'app/core/helpers/must-match.validator';
import { AuthService } from 'app/service/auth/auth.service';
import { PasswordValidator } from 'app/service/password/password.validator';
import { ToastrService } from 'ngx-toastr';
import emailMask from 'text-mask-addons/dist/emailMask';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  signupForm: FormGroup;
  emailMaskHtml = emailMask;

  constructor(
    public fb: FormBuilder,
    public authService: AuthService,
    private toastr: ToastrService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.signupForm = this.fb.group({
      firstNameSignup: ['', Validators.required],
      lastNameSignup: ['', Validators.required],
      emailSignup: ['', [Validators.required, Validators.email]],
      passwordSignup: ['', [Validators.required, Validators.minLength(6), PasswordValidator.strong]],
      confirmpasswordSignup: ['', [Validators.required, PasswordValidator.strong]],
    }, {
      validator: MustMatch('passwordSignup', 'confirmpasswordSignup')
    });
  } // fin ngOnInit

  registerUser() {
    this.authService.signUp(this.signupForm.value).subscribe((res: any) => {
      if (res.message === 'User successfully created!') {
        this.signupForm.reset();
        this.router.navigate(['/signin']);
        this.toastr.success('Compte créé avec succès');
      } else if (res.message === 'Email already in use') {
        this.toastr.warning('Adresse mail déjà utilisée');
      } else {
        this.toastr.error('Le serveur a rencontré un problème');
      }
    });
  }

}
